/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { signInActions } from '../sign-in/slice';
/**
 * Initial states of visual function are defined here
 */
export const initialState = {
  //
  loading: false,
  visuals: [],
  visualById: [],
  reports: [],
  pageNames: [],
  isSessionTimedOut: false,
};
/**
 * All actions related to visual feature are defined here
 */
export const visualSlice = createSlice({
  name: 'feature/visual',
  initialState,
  reducers: {
    getVisuals(state) {
      state.loading = true;
    },
    getVisualsSucceeded(state, action) {
      state.loading = false;
      state.visuals = action?.payload.results;
    },
    getVisualsFailed(state) {
      state.loading = false;
    },
    createVisuals(state) {
      state.loading = true;
    },
    createVisualsSucceeded(state, action) {
      state.loading = false;
      state.visuals = [...state.visuals, action?.payload];
    },
    createVisualsFailed(state) {
      state.loading = false;
    },
    updateVisual(state) {
      state.loading = true;
    },
    updateVisualSucceeded(state, action) {
      state.loading = false;
      state.visuals = state?.visuals?.map((object) =>
        object?.id === action?.payload?.id ? { ...object, ...action.payload } : object
      );
    },
    updateVisualFailed(state) {
      state.loading = false;
    },
    deleteVisual(state) {
      state.loading = true;
    },
    deleteVisualSucceeded(state, action) {
      state.loading = false;
      state.visuals = state?.visuals?.filter((object) => object?.id !== action?.payload?.data?.id);
    },
    deleteVisualFailed(state) {
      state.loading = false;
    },
    getVisualById(state) {
      state.loading = true;
    },
    getVisualByIdSucceeded(state, action) {
      state.loading = false;
      state.visualById = action?.payload;
    },
    getVisualByIdFailed(state) {
      state.loading = false;
    },
    getReports(state) {
      state.loading = true;
    },
    getReportsSucceeded(state, action) {
      state.loading = false;
      state.reports = action?.payload;
    },
    getReportsFailed(state) {
      state.loading = false;
    },
    getReportPages(state) {
      state.loading = true;
    },
    getReportPagesSucceeded(state, action) {
      state.loading = false;
      state.reportPages = action?.payload;
    },
    getReportPagesFailed(state) {
      state.loading = false;
    },
    resetReportPages(state) {
      state.reportPages = [];
    },
    setSessionTimeOut(state, action) {
      state.isSessionTimedOut = action?.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(signInActions.signIn, (state) => ({
      ...state,
      ...initialState,
    }));
  },
});
//
export const { actions: visualActions } = visualSlice;
